/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import EstateListCard, { EstateListQuery } from '../estate/EstateListCard'
import { Container } from '@mantine/core'
import { getEstateCreateLink } from '../../lib/links/estateLinks'
import Page from '../../../../client/js/components/Page'
import { useRouteLoaderData } from '../../../../client/js/components/RouteLoaderData'
import CustomerBreadcrumb from './CustomerBreadcrumb'

function CustomerEstateListPage () {
  const intl = useIntl()
  const params = useParams<{ id: string }>()
  const customerId = parseInt(params.id, 10)
  const customer = useRouteLoaderData<Customer>()

  const [searchParams, setSearchParams] = useQueryParams()
  const searchQuery: EstateListQuery = useMemo(() => ({
    ...searchParams,
    ownerId: params.id
  }), [params.id, searchParams])

  const title = intl.formatMessage({
    id: 'estates',
    defaultMessage: 'Biens'
  })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <CustomerBreadcrumb
          customer={customer}
          title={title}
        />

        <EstateListCard
          createLink={getEstateCreateLink({ ownerId: customerId })}
          query={searchQuery}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default CustomerEstateListPage
